import { FunctionComponent, ReactElement, useState } from 'react';
import {MqttGeoLocationPoint} from '../types';
import { RouteDurationHistory } from './CarLocation';
import { binarySearch , getSubstitutedDay} from '../helpers';
import {Box , Slider} from '@mui/material';
import { styled } from '@mui/material/styles';


interface RouteDurationSliderProps extends RouteDurationHistory{
    geolocationList:MqttGeoLocationPoint[] | null;
    pickDayHandler:(day:number)=>void;
};

interface Marks{
    value:number;
    label:React.ReactElement | string;
};

const StyledSlider = styled(Slider)(({ theme }) => ({
  '& .MuiSlider-thumb': {
  },
  '& .MuiSlider-mark':{
  },
  '& .MuiSlider-markLabel':{
  },
  '& .MuiSlider-valueLabel':{
  }
}));

const renderMarks = (
   geolocationList:MqttGeoLocationPoint[],
   range:number[],
   max:number,
   comparisonConfig: any,
   dividingMonthsIndex:number
   ):Marks[]=>{
    let marks:Marks[] = [];

    range.forEach( (day:number) =>{
      const values = Object.values(comparisonConfig || {});
      const findIndex = binarySearch(values.includes(day) ? geolocationList.slice(0, dividingMonthsIndex) : geolocationList.slice(dividingMonthsIndex), day);
      const fakeDay = getSubstitutedDay(day, comparisonConfig);

      if(findIndex > -1){
        marks.push({
            value: fakeDay ?? day,
            label: <div style={{color:'#3271a8'}}><strong>{day}</strong></div>,
        })
      }else{
        marks.push({
            value: fakeDay ?? day,
            label: <div style={{opacity:.5}}>{day}</div>,
        })
      }
    })

    marks.push({
        value: max+1,
        label:<div style={{color:'#3271a8'}}><strong>Live</strong></div>
    })

    return marks;
}

export const RouteDurationSlider:FunctionComponent<RouteDurationSliderProps>= (props):ReactElement=>{
    const { geolocationList, pickDayHandler, range, max, min, comparisonConfig, dividingMonthsIndex} = props;
    const [val, setVal] = useState<number>(max + 1);

    const handleChange = (_: Event, newValue:number | number[]) => {
       if(typeof newValue === 'number'){
          const substitutedDayValue = (comparisonConfig && comparisonConfig[`${newValue}`]) ?? null;
          if(newValue === max + 1){
            setVal(newValue);
          }
          else if(
            newValue < max + 1 &&
            geolocationList &&
            binarySearch(substitutedDayValue ? geolocationList.slice(0, dividingMonthsIndex) : geolocationList.slice(dividingMonthsIndex), substitutedDayValue ?? newValue) > -1
          ){
            setVal(newValue);
          }else{
           return;
          }

         pickDayHandler(newValue);
       }
    };


    return (
        <Box sx={{ width:250 , maxWidth:350, padding:'0px 10px', marginLeft:'10px'}}>
          <StyledSlider
            step={1}
            value={val}
            track='inverted'
            valueLabelDisplay="off"
            min={min}
            max={max + 1}
            sx={{
              height: '2px',
              marginTop:'5px',
            }}
            size='medium'
            onChange={handleChange}
            marks={renderMarks(geolocationList!, range, max, comparisonConfig, dividingMonthsIndex)}
          />
        </Box>
    )
}